import Service, { inject as service } from '@ember/service';

/*
 * This service was built so we can override English translations for
 * different countries that use the "en" locale (this can support other
 * locales as well, but initially the service was built for the "en" locale).
 * Example:
 * - For Japan, there's no locale called "en-jp", so Japan sellers who use
 *   English in their browser will have their locale set to "en". This can
 *   cause conflicts because many countries use the "en" locale. This
 *   service solves this problem by allowing us to show different English
 *   copy for Japan sellers (even when they are using "en" locale).
 * Usage:
 * - To add different English copy for Japan, add a key to the "en" locale
 *   file: frontend/@capital/intl/translations/src/en.yaml and nest it
 *   inside a key called "jp"
 * - {{sq-intl "offerSelection.mcaGlobal.title"}}
 *   This checks for the key "jp.offerSelection.mcaGlobal.title". If that
 *   key doesn't exist, it falls back to "offerSelection.mcaGlobal.title"
 * Note:
 * - If the country already has a its own English locale (for example,
 *   UK has the locale "en-gb") we should put the overrides in the file
 *   frontend/@capital/intl/translations/src/overrides/en-gb.yaml instead.
 */

export default Service.extend({
  capitalEngineContext: service(),
  intl: service(),
  t(key, params) {
    let translationKey;
    const newParams = Object.assign({}, params);

    // Japan has custom English so we want to use the jp prefixed version of keys for those strings
    // Japanese translations will all be prefixed with jp
    if (this.capitalEngineContext.localeContext.countryCode === 'JP') {
      translationKey = `jp.${key}`;
      // line breaks will be part of Japanese translations so we want to honor these in the html
      newParams.htmlSafe = true;
      if (!this.intl.t(translationKey, newParams).string.startsWith('Missing translation')) {
        return this.intl.t(translationKey, newParams);
      }
    }
    return this.intl.t(key, params);
  }
});